import { Link } from "react-router-dom";
import { ScrollSection } from "@/components/main-page/ScrollSection";

export function AboutClosingCTA() {
  return (
    <ScrollSection
      id="learn-more"
      title="Want to learn more?"
      subtitle="Read about our platform, see what we're building, or just get in touch."
      compact
    >
      <div className="flex flex-wrap gap-4">
        <Link
          to="/contact"
          className="inline-flex items-center px-6 py-3 rounded-full text-sm font-medium bg-[var(--color-fg)] text-[var(--color-bg)] hover:opacity-90 transition-opacity"
        >
          Get in touch
        </Link>
        <Link
          to="/platform"
          className="inline-flex items-center px-6 py-3 rounded-full text-sm font-medium border border-[var(--color-border)] text-[var(--color-fg-secondary)] hover:text-[var(--color-fg)] hover:border-[var(--color-fg-secondary)] transition-colors"
        >
          View the platform →
        </Link>
        <Link
          to="/products"
          className="inline-flex items-center px-6 py-3 rounded-full text-sm font-medium border border-[var(--color-border)] text-[var(--color-fg-secondary)] hover:text-[var(--color-fg)] hover:border-[var(--color-fg-secondary)] transition-colors"
        >
          See our products →
        </Link>
      </div>
    </ScrollSection>
  );
}
